// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/styles/" + "styles" + "." + "ed4ea452bff6389c4797" + ".css";
};